import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import styleClasses from "./RegistrationForm.module.css";
import formClasses from "../forms/Forms.module.css";

import { SpinningCircles } from "react-loading-icons";
import { IconContext } from "react-icons";
import { CiCirclePlus } from "react-icons/ci";
import { IoCloseCircleOutline } from "react-icons/io5";

import Button from "../Button";
import RegisterButton from "./RegisterButton";
import LineSeparator from "../LineSeparator";

import CheckoutContext from "../../store/CheckoutContext";
import EventContext from "../../store/EventContext";
import UserInfoContext from "../../store/UserInfoContext";

const MAPAConv = () => {
  const eventCtx = useContext(EventContext);
  const userCtx = useContext(UserInfoContext);
  const checkoutCtx = useContext(CheckoutContext);

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState();
  const [submitMessage, setSubmitMessage] = useState();
  const [didComplete, setDidComplete] = useState();

  const [delegateName, setDelegateName] = useState("");
  const [delegateEmail, setDelegateEmail] = useState("");
  const [adultInputName, setAdultInputName] = useState("");
  const [adultInputEmail, setAdultInputEmail] = useState("");
  const [childInputName, setChildInputName] = useState("");
  const [childInputAge, setChildInputAge] = useState("");
  const [adultAttendees, setAdultAttendees] = useState([]);
  const [childAttendees, setChildAttendees] = useState([]);
  const [welcomeReceptionCount, setWelcomeReceptionCount] = useState();
  const [memberMeetingCount, setMemberMeetingCount] = useState();
  const [BODfMeetingCount, setBODMeetingCount] = useState();
  const [presDinnerCount, setPresDinnerCount] = useState();
  const [golfCount, setGolfCount] = useState();
  const [sponsorship, setSponsorship] = useState("Please Select");
  const [isPresDinnerSelect, setIsPresDinnerSelect] = useState();
  const [isPresReceptionSelect, setIsPresReceptionSelect] = useState();
  const [isWelcomeRecSelect, setIsWelcomeRecSelect] = useState();
  const [isWristbandSelect, setIsWristbandSelect] = useState();
  const [isRoomKeySelect, setIsRoomKeySelect] = useState();
  const [hospitalitySponsor, setHospitalitySponsor] = useState([]);
  const [breakfastSponsor, setBreakfastSponsor] = useState([]);
  const [isEntertainmentSelect, setIsEntertainmentSelect] = useState();

  const [attendeeTotal, setAttendeeTotal] = useState(
    eventCtx.selectedEvent.price_obj.attendee_price.delegate
  );
  const [sponsorshipPrice, setSponsorshipPrice] = useState(
    eventCtx.selectedEvent.price_obj.sponsorship["Please Select"]
  );
  const [optSponsorshipsPrice, setOptSponsorshipsPrice] = useState(0);
  const [selectedSponsorshipDetails, setSelectedSponsorshipDetails] =
    useState("");

  const [payMethod, setPayMethod] = useState();

  const [inputError, setInputError] = useState();

  useEffect(() => {
    setDelegateName(`${userCtx.firstName} ${userCtx.lastName}`);
    setDelegateEmail(userCtx.email);
  }, [userCtx]);

  const customizedInputObj = () => {
    const adults = [];
    adultAttendees.forEach((adult) =>
      adults.push(`${adult.name}: ${adult.email}`)
    );
    const children = [];
    childAttendees.forEach((child) =>
      children.push(`${child.name}: ${child.age}`)
    );

    const events = [];
    welcomeReceptionCount &&
      events.push(`Welcome Reception: ${welcomeReceptionCount}`);
    memberMeetingCount && events.push(`Members Meeting: ${memberMeetingCount}`);
    BODfMeetingCount && events.push(`Board Meeting: ${BODfMeetingCount}`);
    presDinnerCount && events.push(`President Rec/Dinner: ${presDinnerCount}`);
    golfCount && events.push(`Golf: ${golfCount}`);

    const optSponsorships = [];
    isPresDinnerSelect && optSponsorships.push("Presidents Dinner");
    isPresReceptionSelect && optSponsorships.push("Presidents Reception");
    isWelcomeRecSelect && optSponsorships.push("Welcome Reception");
    isWristbandSelect && optSponsorships.push("Wristband Sponsor");
    isRoomKeySelect && optSponsorships.push("Room Key Sponsor");
    hospitalitySponsor.length !== 0 &&
      optSponsorships.push(`Hospitality Sponsor: ${hospitalitySponsor}`);
    breakfastSponsor.length !== 0 &&
      optSponsorships.push(`Breakfast Sponsor: ${breakfastSponsor}`);
    isEntertainmentSelect && optSponsorships.push("Entertainment Sponsor");

    const customObj = {
      Adults_Attending: adults,
      Children_Attending: children,
      Events_Attending: events,
      Sponsorship: sponsorship,
      Optional_Sponsorships: optSponsorships,
    };

    return customObj;
  };

  const { format } = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
  });

  const AdultAttendeeInfo = () => {
    return (
      <div
        className={`${formClasses.gridContainer}`}
        style={{ gridTemplateColumns: "3fr 3fr 1fr", paddingInline: "15%" }}
      >
        <input
          type="text"
          value={adultInputName}
          placeholder="Spouse/Guest Name"
          onBlur={() => {
            if (adultInputName !== "") {
              setInputError("Please add Attendee");
            } else {
              setInputError("");
            }
          }}
          onChange={(e) => setAdultInputName(e.target.value)}
        />
        <input
          type="text"
          value={adultInputEmail}
          placeholder="Email"
          onBlur={() => {
            if (adultInputEmail !== "") {
              setInputError("Please add Attendee");
            } else {
              setInputError("");
            }
          }}
          onChange={(e) => setAdultInputEmail(e.target.value)}
        />
        <div>
          <IconContext.Provider
            value={{
              size: "2em",
              style: { padding: "0", textAlign: "left" },
            }}
          >
            <CiCirclePlus
              style={{ color: "#FFA559" }}
              onClick={() => {
                const adultAttendee = {
                  name: adultInputName,
                  email: adultInputEmail,
                };
                if (adultInputName && adultInputEmail) {
                  setAdultAttendees((prev) => [...prev, adultAttendee]);
                  setInputError("");
                } else {
                  setInputError("Please enter all information for Child");
                }
                setAdultInputName("");
                setAdultInputEmail("");
                setAttendeeTotal(
                  (prev) =>
                    +prev +
                    +eventCtx.selectedEvent.price_obj.attendee_price.guest
                );
              }}
            />
          </IconContext.Provider>
        </div>
      </div>
    );
  };

  const determinePriceForChild = (age) => {
    if (age >= 6) {
      return eventCtx.selectedEvent.price_obj.attendee_price.child_six_up;
    } else {
      return eventCtx.selectedEvent.price_obj.attendee_price.child_below_6;
    }
  };

  const ChildAttendeeInfo = () => {
    return (
      <div
        className={`${formClasses.gridContainer}`}
        style={{ gridTemplateColumns: "3fr 3fr 1fr", paddingInline: "15%" }}
      >
        <input
          type="text"
          value={childInputName}
          placeholder="Child Name"
          onBlur={() => {
            if (childInputName !== "") {
              setInputError("Please add Attendee");
            } else {
              setInputError("");
            }
          }}
          onChange={(e) => setChildInputName(e.target.value)}
        />
        <input
          type="number"
          value={childInputAge}
          placeholder="Age"
          onBlur={() => {
            if (childInputAge !== "") {
              setInputError("Please add Attendee");
            } else {
              setInputError("");
            }
          }}
          onChange={(e) => setChildInputAge(e.target.value)}
        />
        <div>
          <IconContext.Provider
            value={{ size: "2em", style: { padding: "0" } }}
          >
            <CiCirclePlus
              style={{ color: "#FFA559" }}
              onClick={() => {
                const childAttendee = {
                  name: childInputName,
                  age: childInputAge,
                };
                if (childInputName && childInputAge) {
                  setChildAttendees((prev) => [...prev, childAttendee]);
                  setInputError("");
                } else {
                  setInputError("Please enter all information for Child");
                }
                setAttendeeTotal(
                  (prev) => +prev + +determinePriceForChild(+childInputAge)
                );
                setChildInputName("");
                setChildInputAge("");
              }}
            />
          </IconContext.Provider>
        </div>
      </div>
    );
  };

  return (
    <div className={styleClasses.page}>
      <h2>{eventCtx.selectedEvent.event_date_obj.dates}</h2>
      <section
        className={`${styleClasses.section} ${styleClasses.borderOrange}`}
      >
        <div
          className={`${styleClasses.backgroundOrange} ${styleClasses.headingBackground}`}
        >
          <h3>Attendees</h3>
        </div>
        <table
          className={`${styleClasses.table} ${styleClasses.flex} ${styleClasses.flexColumn} ${styleClasses.center} ${styleClasses.leftAlign}`}
        >
          <tbody>
            <tr>
              <th>Delegate</th>
              <td>
                {format(
                  eventCtx.selectedEvent.price_obj.attendee_price.delegate
                )}
              </td>
            </tr>
            <tr>
              <th>Spouse/Guest</th>
              <td>
                {format(eventCtx.selectedEvent.price_obj.attendee_price.guest)}
              </td>
            </tr>
            <tr>
              <th>Children 6 and up</th>
              <td>
                {format(
                  eventCtx.selectedEvent.price_obj.attendee_price.child_six_up
                )}
              </td>
            </tr>
            <tr>
              <th>Children 5 and under</th>
              <td>
                {eventCtx.selectedEvent.price_obj.attendee_price
                  .child_below_6 === "0"
                  ? "Free"
                  : format(
                      eventCtx.selectedEvent.price_obj.attendee_price
                        .child_below_6
                    )}
              </td>
            </tr>
          </tbody>
        </table>
        <br />
        <br />
        <div
          className={`${formClasses.gridContainer} ${formClasses.gridThreeCol} ${formClasses.textAlignAllCenter}`}
        >
          <p>
            <b>Delegate:</b> {delegateName}
          </p>
          <p>
            <b>Email:</b> {delegateEmail}
          </p>
          <p>
            <b>Price:</b>{" "}
            {format(eventCtx.selectedEvent.price_obj.attendee_price.delegate)}
          </p>
        </div>
        <br />
        {adultAttendees.map((att, index) => (
          <div key={index} style={{ display: "flex" }}>
            <IconContext.Provider value={{ size: "20px", color: "#ffa559" }}>
              <IoCloseCircleOutline
                onClick={() => {
                  setAdultAttendees((prev) =>
                    prev.filter((att, i) => i !== index)
                  );
                  setAttendeeTotal(
                    (prev) =>
                      prev -
                      eventCtx.selectedEvent.price_obj.attendee_price.guest
                  );
                }}
              />
            </IconContext.Provider>
            <div
              className={`${styleClasses.infoCard}`}
              key={`${att["name"]}${att["email"]}`}
            >
              <p>
                <b>Guest:</b> {att["name"]}
              </p>
              <p>
                <b>Email:</b> {att["email"]}
              </p>
              <p>
                <b>Price:</b>{" "}
                {format(eventCtx.selectedEvent.price_obj.attendee_price.guest)}
              </p>
            </div>
          </div>
        ))}
        {childAttendees.map((att, index) => (
          <div key={index} style={{ display: "flex" }}>
            <IconContext.Provider value={{ size: "20px", color: "#ffa559" }}>
              <IoCloseCircleOutline
                onClick={() => {
                  setChildAttendees((prev) =>
                    prev.filter((att, i) => i !== index)
                  );
                  setAttendeeTotal(
                    (prev) => prev - determinePriceForChild(+att["age"])
                  );
                }}
              />
            </IconContext.Provider>
            <div
              className={`${styleClasses.infoCard}`}
              key={`${att["name"]}${att["age"]}`}
            >
              <p>
                <b>Child Name:</b> {att["name"]}
              </p>
              <p>
                <b>Age:</b> {att["age"]}
              </p>
              <p>
                <b>Price:</b> {format(determinePriceForChild(+att["age"]))}
              </p>
            </div>
          </div>
        ))}
        <br />
        <br />
        {AdultAttendeeInfo()}
        <br />
        {ChildAttendeeInfo()}
        <br />
        <br />
        <h2>Attendee Total: {format(attendeeTotal)}</h2>
        <br />
        <p style={{ color: "red", textAlign: "center" }}>{inputError}</p>
      </section>
      <section
        className={`${styleClasses.section} ${styleClasses.borderOrange}`}
      >
        <div
          className={`${styleClasses.backgroundOrange} ${styleClasses.headingBackground}`}
        >
          <h3>Event Attendance</h3>
        </div>
        <p style={{ textAlign: "center" }}>
          Please indicate how many will be attending each of the following
          events
        </p>
        <br />
        <div
          className={`${formClasses.gridFourCol} ${formClasses.gridContainer}`}
        >
          <label htmlFor="welcome_reception" style={{ textAlign: "center" }}>
            Welcome Reception:
          </label>
          <input
            type="number"
            placeholder="Enter number"
            onChange={(e) => setWelcomeReceptionCount(e.target.value)}
          />
          <label htmlFor="member_meeting" style={{ textAlign: "center" }}>
            Member Meeting:
          </label>
          <input
            type="number"
            placeholder="Enter number"
            onChange={(e) => setMemberMeetingCount(e.target.value)}
          />
          <label htmlFor="dir_meeting" style={{ textAlign: "center" }}>
            Board of Directors Meeting:
          </label>
          <input
            type="number"
            placeholder="Enter number"
            onChange={(e) => setBODMeetingCount(e.target.value)}
          />
          <label htmlFor="pres_dinner" style={{ textAlign: "center" }}>
            Presidents Reception & Dinner:
          </label>
          <input
            type="number"
            placeholder="Enter number"
            onChange={(e) => setPresDinnerCount(e.target.value)}
          />
          <label htmlFor="golf" style={{ textAlign: "center" }}>
            Golf:
          </label>
          <input
            type="number"
            placeholder="Enter number"
            onChange={(e) => setGolfCount(e.target.value)}
          />
        </div>
      </section>
      <section
        className={`${styleClasses.section} ${styleClasses.borderOrange}`}
      >
        <div
          className={`${styleClasses.backgroundOrange} ${styleClasses.headingBackground}`}
        >
          <h3>Sponsorship</h3>
        </div>
        <select
          name="sponsorship"
          id="sponsorship"
          onChange={(e) => {
            //USE THE VALUE (WHICH IS THE ARRAY ID) PASSED FROM THE select ELEMENT TO
            // RECONSTRUCT THE SORTED ARRAY OR ARRAYS AND THEN GET THE CORRECT ARRAY THAT
            // WAS ORIGINALLY SELECTED
            const selectedSponsorship = Object.entries(
              eventCtx.selectedEvent.price_obj.sponsorship
            ).sort((a, b) => Number(a[1]) - Number(b[1]))[e.target.value];

            //USE THAT ARRAY TO SET STATE THAT GETS PASSED TO CHECKOUT
            setSponsorship(`${selectedSponsorship[0]} Sponsor`);
            setSponsorshipPrice(selectedSponsorship[1]);
          }}
        >
          {Object.entries(eventCtx.selectedEvent.price_obj.sponsorship)
            .sort((a, b) => Number(a[1]) - Number(b[1]))
            .map((arr, index) => {
              return (
                <option key={index} value={index}>
                  {arr[0] !== "Please Select"
                    ? `${arr[0]} - $${arr[1]}`
                    : arr[0]}
                </option>
              );
            })}
        </select>
        <div className={styleClasses.detailLists}>
          <h4>Platinum:</h4>
          <ul>
            {eventCtx.selectedEvent.price_obj.sponsorshipDetails.Platinum.map(
              (detail, index) => (
                <li key={index}>{detail}</li>
              )
            )}
          </ul>
          <h4>Gold:</h4>
          <ul>
            {eventCtx.selectedEvent.price_obj.sponsorshipDetails.Gold.map(
              (detail, index) => (
                <li key={index}>{detail}</li>
              )
            )}
          </ul>
          <h4>Silver:</h4>
          <ul>
            {eventCtx.selectedEvent.price_obj.sponsorshipDetails.Silver.map(
              (detail, index) => (
                <li key={index}>{detail}</li>
              )
            )}
          </ul>
        </div>
        <h2>{`Sponsorship Total: ${format(sponsorshipPrice)}`}</h2>
      </section>
      <section
        className={` ${styleClasses.section} ${styleClasses.borderOrange}`}
      >
        <div
          className={`${styleClasses.backgroundOrange} ${styleClasses.headingBackground}`}
        >
          <h3>Optional Sponorship Opportunities</h3>
        </div>
        <h3 style={{ marginBottom: "0px" }}>
          <i>Select one</i>
        </h3>
        <h3 style={{ marginBlock: "0px" }}>
          <i>Selections in red are already sponsored</i>
        </h3>
        <h3 style={{ marginTop: "0px", fontSize: "90%" }}>
          <i>Click selections to view details</i>
        </h3>
        <div
          className={`${styleClasses.checkbox} ${styleClasses.detailLists} `}
          style={{ marginBottom: "2em" }}
        >
          <div style={{ minWidth: "330px", textAlign: "left" }}>
            <input
              type="checkbox"
              disabled={
                eventCtx.selectedEvent.price_obj.optionalSponsorshipComplete
                  .Presidents_Dinner
                  ? "disabled"
                  : ""
              }
              name="opt-sponsorship"
              value="President's Dinner"
              onChange={(e) => {
                if (e.target.checked) {
                  setOptSponsorshipsPrice(
                    (prev) =>
                      (prev +=
                        +eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Presidents_Dinner"
                        ])
                  );
                } else {
                  setOptSponsorshipsPrice(
                    (prev) =>
                      (prev -=
                        +eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Presidents_Dinner"
                        ])
                  );
                }
                setIsPresDinnerSelect(e.target.checked);
              }}
            />
            <label
              style={{
                color: `${
                  eventCtx.selectedEvent.price_obj.optionalSponsorshipComplete
                    .Presidents_Dinner
                    ? "red"
                    : ""
                }`,
              }}
              onClick={() =>
                setSelectedSponsorshipDetails(
                  <ul>
                    {eventCtx.selectedEvent.price_obj.optionalSponsorshipDetails.Presidents_Dinner.map(
                      (listItem, index) => {
                        return <li key={index}>{listItem}</li>;
                      }
                    )}
                  </ul>
                )
              }
            >
              President's Dinner{" "}
              {format(
                eventCtx.selectedEvent.price_obj.optionalSponsorship
                  .Presidents_Dinner
              )}
            </label>
          </div>
          <div style={{ minWidth: "330px", textAlign: "left" }}>
            <input
              type="checkbox"
              disabled={
                eventCtx.selectedEvent.price_obj.optionalSponsorshipComplete
                  .Presidents_Reception
                  ? "disabled"
                  : ""
              }
              name="opt-sponsorship"
              value="President's Reception"
              onChange={(e) => {
                if (e.target.checked) {
                  setOptSponsorshipsPrice(
                    (prev) =>
                      (prev +=
                        +eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Presidents_Reception"
                        ])
                  );
                } else {
                  setOptSponsorshipsPrice(
                    (prev) =>
                      (prev -=
                        +eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Presidents_Reception"
                        ])
                  );
                }
                setIsPresReceptionSelect(e.target.checked);
              }}
            />
            <label
              style={{
                color: `${
                  eventCtx.selectedEvent.price_obj.optionalSponsorshipComplete
                    .Presidents_Reception
                    ? "red"
                    : ""
                }`,
              }}
              onClick={() =>
                setSelectedSponsorshipDetails(
                  <ul>
                    {eventCtx.selectedEvent.price_obj.optionalSponsorshipDetails.Presidents_Reception.map(
                      (listItem, index) => {
                        return <li key={index}>{listItem}</li>;
                      }
                    )}
                  </ul>
                )
              }
            >
              President's Reception{" "}
              {format(
                eventCtx.selectedEvent.price_obj.optionalSponsorship
                  .Presidents_Reception
              )}
            </label>
          </div>
          <div style={{ minWidth: "330px", textAlign: "left" }}>
            <input
              type="checkbox"
              disabled={
                eventCtx.selectedEvent.price_obj.optionalSponsorshipComplete
                  .Welcome_Reception
                  ? "disabled"
                  : ""
              }
              name="opt-sponsorship"
              value="Welcome Reception"
              onChange={(e) => {
                if (e.target.checked) {
                  setOptSponsorshipsPrice(
                    (prev) =>
                      (prev +=
                        +eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Welcome_Reception"
                        ])
                  );
                } else {
                  setOptSponsorshipsPrice(
                    (prev) =>
                      (prev -=
                        +eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Welcome_Reception"
                        ])
                  );
                }
                setIsWelcomeRecSelect(e.target.checked);
              }}
            />
            <label
              style={{
                color: `${
                  eventCtx.selectedEvent.price_obj.optionalSponsorshipComplete
                    .Welcome_Reception
                    ? "red"
                    : ""
                }`,
              }}
              onClick={() =>
                setSelectedSponsorshipDetails(
                  <ul>
                    {eventCtx.selectedEvent.price_obj.optionalSponsorshipDetails.Welcome_Reception.map(
                      (listItem, index) => {
                        return <li key={index}>{listItem}</li>;
                      }
                    )}
                  </ul>
                )
              }
            >
              Welcome Reception{" "}
              {format(
                eventCtx.selectedEvent.price_obj.optionalSponsorship
                  .Welcome_Reception
              )}
            </label>
          </div>
        </div>
        <div
          className={`${styleClasses.checkbox} ${styleClasses.detailLists} `}
          style={{ marginBottom: "2em" }}
        >
          <div style={{ minWidth: "330px", textAlign: "left" }}>
            <input
              type="checkbox"
              disabled={
                eventCtx.selectedEvent.price_obj.optionalSponsorshipComplete
                  .Wristband_Sponsor
                  ? "disabled"
                  : ""
              }
              name="opt-sponsorship"
              value="Wrist Band Sponsor"
              onChange={(e) => {
                if (e.target.checked) {
                  setOptSponsorshipsPrice(
                    (prev) =>
                      (prev +=
                        +eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Wristband_Sponsor"
                        ])
                  );
                } else {
                  setOptSponsorshipsPrice(
                    (prev) =>
                      (prev -=
                        +eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Wristband_Sponsor"
                        ])
                  );
                }
                setIsWristbandSelect(e.target.checked);
              }}
            />
            <label
              style={{
                color: `${
                  eventCtx.selectedEvent.price_obj.optionalSponsorshipComplete
                    .Wristband_Sponsor
                    ? "red"
                    : ""
                }`,
              }}
              onClick={() =>
                setSelectedSponsorshipDetails(
                  <ul>
                    {eventCtx.selectedEvent.price_obj.optionalSponsorshipDetails.Wristband_Sponsor.map(
                      (listItem, index) => {
                        return <li key={index}>{listItem}</li>;
                      }
                    )}
                  </ul>
                )
              }
            >
              Wristband Sponsor{" "}
              {format(
                eventCtx.selectedEvent.price_obj.optionalSponsorship
                  .Wristband_Sponsor
              )}
            </label>
          </div>
          <div style={{ minWidth: "330px", textAlign: "left" }}>
            <input
              type="checkbox"
              disabled={
                eventCtx.selectedEvent.price_obj.optionalSponsorshipComplete
                  .Room_Key_Sponsor
                  ? "disabled"
                  : ""
              }
              name="opt-sponsorship"
              value="Room Key Sponsor"
              onChange={(e) => {
                if (e.target.checked) {
                  setOptSponsorshipsPrice(
                    (prev) =>
                      (prev +=
                        +eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Room_Key_Sponsor"
                        ])
                  );
                } else {
                  setOptSponsorshipsPrice(
                    (prev) =>
                      (prev -=
                        +eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Room_Key_Sponsor"
                        ])
                  );
                }
                setIsRoomKeySelect(e.target.checked);
              }}
            />
            <label
              htmlFor="pay-method"
              style={{
                color: `${
                  eventCtx.selectedEvent.price_obj.optionalSponsorshipComplete
                    .Room_Key_Sponsor
                    ? "red"
                    : ""
                }`,
              }}
              onClick={() =>
                setSelectedSponsorshipDetails(
                  <ul>
                    {eventCtx.selectedEvent.price_obj.optionalSponsorshipDetails.Room_Key_Sponsor.map(
                      (listItem, index) => {
                        return <li key={index}>{listItem}</li>;
                      }
                    )}
                  </ul>
                )
              }
            >
              Room Key Sponsor{" "}
              {format(
                eventCtx.selectedEvent.price_obj.optionalSponsorship
                  .Room_Key_Sponsor
              )}
            </label>
          </div>
        </div>
        <div className={`${styleClasses.flex} ${styleClasses.center}`}>
          <div style={{ textAlign: "left" }}>{selectedSponsorshipDetails}</div>
        </div>

        {/* <div className={styleClasses.detailLists}>
          <h4>President's Dinner:</h4>
          <ul>
            {eventCtx.selectedEvent.price_obj.optionalSponsorshipDetails[
              "Presidents_Dinner"
            ].map((listItem, index) => (
              <li key={index}>{listItem}</li>
            ))}
          </ul>
          <h4>President's Reception:</h4>
          <ul>
            {eventCtx.selectedEvent.price_obj.optionalSponsorshipDetails[
              "Presidents_Reception"
            ].map((listItem, index) => (
              <li key={index}>{listItem}</li>
            ))}
          </ul>
          <h4>Welcome Reception:</h4>
          <ul>
            {eventCtx.selectedEvent.price_obj.optionalSponsorshipDetails[
              "Welcome_Reception"
            ].map((listItem, index) => (
              <li key={index}>{listItem}</li>
            ))}
          </ul>
        </div> */}
        {/* <div className={styleClasses.detailLists}>
          <h4>Wrist Band Sponsor:</h4>
          <ul>
            {eventCtx.selectedEvent.price_obj.optionalSponsorshipDetails[
              "Wristband_Sponsor"
            ].map((detail, index) => (
              <li key={index}>{detail}</li>
            ))}
          </ul>
        </div> */}
        {/* <LineSeparator /> */}
        {/* <br />
        <h3 style={{ marginBottom: "0px" }}>
          <i>Select all that apply</i>
        </h3>
        <h3 style={{ marginTop: "0px" }}>
          <i>Selections in red are already sponsored</i>
        </h3> */}
        <div
          className={`${styleClasses.checkbox} ${styleClasses.detailLists}`}
          style={{ marginBottom: "2em" }}
        >
          <div style={{ marginRight: "30px" }}>
            <h2>Hospitality Suite</h2>
            <p style={{ textAlign: "center" }}>
              <i>
                $
                {
                  eventCtx.selectedEvent.price_obj.optionalSponsorship[
                    "Hospitality_Suite"
                  ]
                }{" "}
                per day
              </i>
            </p>
          </div>
          <div className={`${styleClasses.flex} ${styleClasses.flexColumn}`}>
            {[1, 2, 3, 4].map((i) => {
              return (
                <div key={i}>
                  <input
                    disabled={
                      eventCtx.selectedEvent.price_obj
                        .optionalSponsorshipComplete[`Hospitality_Day_${i}`]
                    }
                    type="checkbox"
                    name="opt-sponsorship"
                    value={`Day ${i}`}
                    onChange={(e) => {
                      if (!hospitalitySponsor.includes(e.target.value)) {
                        setHospitalitySponsor((prev) => [
                          ...prev,
                          e.target.value,
                        ]);
                        setOptSponsorshipsPrice(
                          (prev) =>
                            (prev +=
                              +eventCtx.selectedEvent.price_obj
                                .optionalSponsorship.Hospitality_Suite)
                        );
                      } else {
                        setHospitalitySponsor((prev) =>
                          prev.filter((i) => i !== e.target.value)
                        );
                        setOptSponsorshipsPrice(
                          (prev) =>
                            (prev -=
                              +eventCtx.selectedEvent.price_obj
                                .optionalSponsorship.Hospitality_Suite)
                        );
                      }
                    }}
                  />
                  <label
                    htmlFor="pay-method"
                    style={{
                      color:
                        eventCtx.selectedEvent.price_obj
                          .optionalSponsorshipComplete.Room_Key_Sponsor &&
                        "red",
                    }}
                  >
                    Day {i}
                  </label>
                </div>
              );
            })}
          </div>
          <div style={{ marginInline: "30px" }}>
            <h2>Breakfast Sponsor </h2>
            <p style={{ textAlign: "center" }}>
              <i>
                $
                {
                  eventCtx.selectedEvent.price_obj.optionalSponsorship[
                    "Breakfast_Sponsor"
                  ]
                }{" "}
                per day
              </i>
            </p>
          </div>
          <div className={`${styleClasses.flex} ${styleClasses.flexColumn}`}>
            {[1, 2, 3, 4].map((i) => {
              return (
                <div key={i}>
                  <input
                    disabled={
                      eventCtx.selectedEvent.price_obj
                        .optionalSponsorshipComplete[`Breakfast_Day_${i}`]
                    }
                    type="checkbox"
                    name="opt-sponsorship"
                    value={`Day ${i}`}
                    onChange={(e) => {
                      if (!breakfastSponsor.includes(e.target.value)) {
                        setBreakfastSponsor((prev) => [
                          ...prev,
                          e.target.value,
                        ]);
                        setOptSponsorshipsPrice(
                          (prev) =>
                            (prev +=
                              +eventCtx.selectedEvent.price_obj
                                .optionalSponsorship.Breakfast_Sponsor)
                        );
                      } else {
                        setBreakfastSponsor((prev) =>
                          prev.filter((i) => i !== e.target.value)
                        );
                        setOptSponsorshipsPrice(
                          (prev) =>
                            (prev -=
                              +eventCtx.selectedEvent.price_obj
                                .optionalSponsorship.Breakfast_Sponsor)
                        );
                      }
                    }}
                  />
                  <label
                    htmlFor="pay-method"
                    style={{
                      color:
                        eventCtx.selectedEvent.price_obj
                          .optionalSponsorshipComplete.Room_Key_Sponsor &&
                        "red",
                    }}
                  >
                    Day {i}
                  </label>
                </div>
              );
            })}
          </div>
        </div>
        <div className={styleClasses.detailLists}>
          <h4>Hospitality Suite:</h4>
          <ul>
            {eventCtx.selectedEvent.price_obj.optionalSponsorshipDetails[
              "Hospitality_Suite"
            ].map((detail, index) => (
              <li key={index}>{detail}</li>
            ))}
          </ul>
          <h4>Breakfast Sponsor:</h4>
          <ul>
            {eventCtx.selectedEvent.price_obj.optionalSponsorshipDetails[
              "Breakfast_Sponsor"
            ].map((detail, index) => (
              <li key={index}>{detail}</li>
            ))}
          </ul>
        </div>
        <LineSeparator />
        <br />
        <h3 style={{ marginBottom: "0px" }}>
          <i>Additional Sponsorship opportunity</i>
        </h3>
        <div
          className={`${styleClasses.checkbox} ${styleClasses.detailLists}`}
          style={{ marginBottom: "2em" }}
        >
          <div>
            <input
              type="checkbox"
              name="opt-sponsorship"
              value="Entertainment Sponsor"
              onChange={(e) => {
                if (e.target.checked) {
                  setOptSponsorshipsPrice(
                    (prev) =>
                      (prev +=
                        +eventCtx.selectedEvent.price_obj.optionalSponsorship
                          .Entertainment_Sponsor)
                  );
                } else {
                  setOptSponsorshipsPrice(
                    (prev) =>
                      (prev -=
                        +eventCtx.selectedEvent.price_obj.optionalSponsorship
                          .Entertainment_Sponsor)
                  );
                }
                setIsEntertainmentSelect(e.target.checked);
              }}
            />
            <label htmlFor="pay-method">
              Entertainment Sponsor{" "}
              {format(
                eventCtx.selectedEvent.price_obj.optionalSponsorship
                  .Entertainment_Sponsor
              )}{" "}
              per event
            </label>
          </div>
        </div>
        <div className={styleClasses.detailLists}>
          <h4>Entertainment Sponsor:</h4>
          <ul>
            {eventCtx.selectedEvent.price_obj.optionalSponsorshipDetails[
              "Entertainment_Sponsor"
            ].map((detail, index) => (
              <li key={index}>{detail}</li>
            ))}
          </ul>
        </div>
        <h2>{`Optional Sponsorship Total: ${format(optSponsorshipsPrice)}`}</h2>
      </section>
      <section
        className={` ${styleClasses.section} ${styleClasses.borderOrange}`}
      >
        <h2>
          Grand Total:{" "}
          {format(+attendeeTotal + +sponsorshipPrice + +optSponsorshipsPrice)}
        </h2>
      </section>
      <br />
      {/* <h3>For more information:</h3> */}
      <a
        href={`https://yplstzafkrlvgcnssbfi.supabase.co/storage/v1/object/public/event_storage/${eventCtx.selectedEvent.event_attachment_filename}`}
        target="about_blank"
      >
        Download the PDF registration packet
      </a>
      <br />
      <br />
      <br />
      {isLoading ? (
        <SpinningCircles stroke="#ffffff30" fill="#FFF" speed="1.0" />
      ) : (
        submitMessage
      )}
      {!didComplete && (
        <RegisterButton
          isDisabled={
            adultInputName !== "" ||
            adultInputEmail !== "" ||
            childInputName !== "" ||
            childInputAge !== ""
          }
          setIsLoading={setIsLoading}
          setSubmitMessage={setSubmitMessage}
          didComplete={setDidComplete}
          registrantData={{
            eventID: eventCtx.selectedEvent.id,
            event: eventCtx.selectedEvent,
            company: userCtx.company,
            firstName: userCtx.firstName,
            lastName: userCtx.lastName,
            address: `${userCtx.street} ${userCtx.city} ${userCtx.state} ${userCtx.zip}`,
            email: userCtx.email,
            phone: userCtx.phone,
            customInputs: customizedInputObj(),
          }}
        />
      )}

      {didComplete && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginBottom: "5em",
          }}
        >
          <h2>Pay Method:</h2>
          <div
            className={styleClasses.checkbox}
            style={{ marginBottom: "2em" }}
          >
            <input
              type="radio"
              name="pay-method"
              value="Check"
              onChange={() => setPayMethod("Check")}
            />
            <label htmlFor="pay-method">Check</label>
            <input
              type="radio"
              name="pay-method"
              value="Card"
              onChange={() => setPayMethod("Card")}
            />
            <label htmlFor="pay-method">Card</label>
          </div>
          {payMethod === "Check" && (
            <div style={{ marginBottom: "5em" }}>
              <h3>Please Mail Check to:</h3>
              <p style={{ margin: "0", textAlign: "center" }}>
                Mississippi Asphalt Pavement Association
              </p>
              <p style={{ margin: "0", textAlign: "center" }}>
                711 N. Presidents St.
              </p>
              <p style={{ margin: "0", textAlign: "center" }}>
                Jackson, MS 39202
              </p>
            </div>
          )}
          {payMethod && (
            <Button
              backgroundColor={"#FFA559"}
              shadowColor={"#454545"}
              title={payMethod === "Check" ? "Okay" : "Proceed to Checkout"}
              onClick={() => {
                if (payMethod === "Check") {
                  navigate("/");
                } else {
                  //* Add item for main attendee (delegate)
                  checkoutCtx.addItem({
                    itemName: "Delegate",
                    itemPrice:
                      eventCtx.selectedEvent.price_obj.attendee_price.delegate,
                  });
                  //* Add item for adult attendees
                  checkoutCtx.addItem({
                    itemName: `Adults Guests  X${adultAttendees.length}`,
                    itemPrice:
                      eventCtx.selectedEvent.price_obj.attendee_price.guest *
                      adultAttendees.length,
                  });

                  //* Add item for child attendees (Check for ages)
                  let sixUp = 0;
                  let underSix = 0;
                  childAttendees.forEach((child) => {
                    if (child.age >= 6) {
                      sixUp += 1;
                    } else if (child.age < 6) {
                      underSix += 1;
                    }
                  });
                  checkoutCtx.addItem({
                    itemName: `Children 6+ X${sixUp}`,
                    itemPrice:
                      eventCtx.selectedEvent.price_obj.attendee_price
                        .child_six_up * sixUp,
                  });
                  checkoutCtx.addItem({
                    itemName: `Children under 6 X${underSix}`,
                    itemPrice:
                      eventCtx.selectedEvent.price_obj.attendee_price
                        .child_below_6 * underSix,
                  });
                  //* Add item for sponsorship
                  checkoutCtx.addItem({
                    itemName: sponsorship,
                    itemPrice: sponsorshipPrice,
                  });

                  //* Add item for each opt sponsorships
                  isPresDinnerSelect &&
                    checkoutCtx.addItem({
                      itemName: "President's Dinner Sponsor",
                      itemPrice:
                        eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Presidents_Dinner"
                        ],
                    });

                  isPresReceptionSelect &&
                    checkoutCtx.addItem({
                      itemName: "President's Reception Sponsor",
                      itemPrice:
                        eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Presidents_Reception"
                        ],
                    });

                  isWelcomeRecSelect &&
                    checkoutCtx.addItem({
                      itemName: "Welcome Reception Sponsor",
                      itemPrice:
                        eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Welcome_Reception"
                        ],
                    });

                  isWristbandSelect &&
                    checkoutCtx.addItem({
                      itemName: "Wristband Sponsor",
                      itemPrice:
                        eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Wristband_Sponsor"
                        ],
                    });

                  isRoomKeySelect &&
                    checkoutCtx.addItem({
                      itemName: "Room Key Sponsor",
                      itemPrice:
                        eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Room_Key_Sponsor"
                        ],
                    });

                  hospitalitySponsor &&
                    checkoutCtx.addItem({
                      itemName: `Hospitality Sponsor - ${hospitalitySponsor.length} days`,
                      itemPrice:
                        eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Hospitality_Suite"
                        ] * hospitalitySponsor.length,
                    });

                  breakfastSponsor &&
                    checkoutCtx.addItem({
                      itemName: `Breakfast Sponsor - ${breakfastSponsor.length} days`,
                      itemPrice:
                        eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Breakfast_Sponsor"
                        ],
                    });

                  isEntertainmentSelect &&
                    checkoutCtx.addItem({
                      itemName: "Entertainment Sponsor",
                      itemPrice:
                        eventCtx.selectedEvent.price_obj.optionalSponsorship[
                          "Entertainment_Sponsor"
                        ],
                    });

                  navigate("/checkout");
                }
              }}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default MAPAConv;
